import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Table,
  TableContainer,
  Tbody,
  Text,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import { Lesson } from "../../models/Lesson";
import ProgressRowItem from "./ProgressRowItem";
import { useTranslation } from "react-i18next";

type Props = {
  name: string;
  lessons: Lesson[];
};

export default function ProgressItem({ name, lessons }: Props) {
  const { t } = useTranslation();

  return (
    <Accordion
      bg="gray.100"
      defaultIndex={Array.from(Array(lessons.length).keys())}
      allowMultiple
    >
      <AccordionItem>
        <h2>
          <AccordionButton bg="gray.200">
            <Box as="span" flex="1" textAlign="left">
              <Text p={2} fontSize="xl" fontWeight="bold">
                {name}
              </Text>
            </Box>
            <AccordionIcon />
          </AccordionButton>
        </h2>
        <AccordionPanel py={4}>
          <TableContainer>
            <Table
              __css={{ tableLayout: "fixed", width: "full" }}
              variant="simple"
              bg="white"
            >
              <Thead>
                <Tr>
                  <Th>{t("tables.lessons")}</Th>
                  <Th>{t("tables.exercises")}</Th>
                </Tr>
              </Thead>
              <Tbody>
                {lessons.map(({ id, exams, quizzes, name }) => (
                  <ProgressRowItem
                    key={id}
                    name={name}
                    exams={exams ?? []}
                    quizzes={quizzes ?? []}
                  />
                ))}
              </Tbody>
            </Table>
          </TableContainer>
        </AccordionPanel>
      </AccordionItem>
    </Accordion>
  );
}
